import axios from 'axios'
import storages from './global-storage'

const baseAPILoyalty = process.env.baseAPILoyalty
const shopStorage = storages.shopLocalStorage()
const opts = {
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: false
}

const simpleHttpClient = axios.create(opts)
simpleHttpClient.interceptors.request.use((request) => {
  const shopId = `${shopStorage.getShopId() || ''}`
  // Remove non-ASCII characters to prevent XMLHttpRequest error
  request.headers.shopId = shopId.replace(/[^\x20-\x7E]/g, '')
  return request
})

const secureHttpClient = axios.create(opts)
secureHttpClient.interceptors.request.use((request) => {
  const shopId = `${shopStorage.getShopId() || ''}`
  const userId = `${shopStorage.getUserId() || ''}`
  // Remove non-ASCII characters to prevent XMLHttpRequest error
  request.headers.shopId = shopId.replace(/[^\x20-\x7E]/g, '')
  request.headers.lineUserId = userId.replace(/[^\x20-\x7E]/g, '')
  request.headers.lineId = userId.replace(/[^\x20-\x7E]/g, '')
  return request
})

const apiLoyalty = (method, url, params) => {
  return simpleHttpClient({
    url: `${baseAPILoyalty}/${url}`,
    method: method,
    data: params
  })
}

const apiLoyaltySecure = (method, url, params) => {
  return secureHttpClient({
    url: `${baseAPILoyalty}/${url}`,
    method: method,
    data: params
  })
}

export default {
  apiLoyalty,
  apiLoyaltySecure
}



// WEBPACK FOOTER //
// ./src/apis/http-backbone.js